import { videoQuestionsCss } from "./VideoQuizQuestions.style";

const VideoQuizQuestions = () => (
  <div css={videoQuestionsCss} id="player_activities" />
);

export default VideoQuizQuestions;
